import React from "react"
import Slider from "react-slick"
import Img from "gatsby-image"
import "./perfect-to-product.scss"

const PerfectToProduct = ({ params, isActive }) => {
  return (
    <section className={`f-perfect-to-section `}>
      <Slider
        slidesToShow={2}
        lazyLoad
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              infinite: false,
              dotsClass: "slick-dots f-custom-dots",
              slidesToShow: 1.05,
              dots: true,
            },
          },
        ]}
      >
        <div className="f-slide">
          <Img
            className="f-slide__img"
            objectFit="contain"
            fixed={params.primerPerfectoParaImagen.fixed}
            alt={params.primerPerfectoParaImagen.description}
          />
          <h2 className="f-slide__title">{params.primerPerfectoParaTitulo}</h2>
          <p className="f-slide__description">
            {params.primerPerfectoParaDescripcion.primerPerfectoParaDescripcion}
          </p>
        </div>
        <div className="f-slide">
          <Img
            className="f-slide__img"
            fixed={params.segundoPerfectoParaImagen.fixed}
            alt={params.segundoPerfectoParaImagen.description}
          />
          <h2 className="f-slide__title">{params.segundoPerfectoParaTitulo}</h2>
          <p className="f-slide__description">
            {
              params.segundoPerfectoParaDescripcion
                .segundoPerfectoParaDescripcion
            }
          </p>
        </div>
      </Slider>
    </section>
  )
}

export default PerfectToProduct
